import React, { useEffect, createElement, Component } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { IngredientDemo } from './components/IngredientDemo';
import { DownloadCTA } from './components/DownloadCTA';
import { Footer } from './components/Footer';
import { BlogPage } from './components/BlogPage';
import { BlogPost } from './components/BlogPost';
import { AboutPage } from './components/AboutPage';
import { HowToGuide } from './components/HowToGuide';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsOfService } from './components/TermsOfService';
import { ContactSupport } from './components/ContactSupport';
import { EditorialPolicy } from './components/EditorialPolicy';
import { Testimonials } from './components/Testimonials';
import { WhatItDoes } from './components/WhatItDoes';
import { WhyIngredientsMatter } from './components/WhyIngredientsMatter';
import { IngredientCategories } from './components/IngredientCategories';
import { AppScreenshots } from './components/AppScreenshots';
import { FAQ } from './components/FAQ';
import { LatestBlogPosts } from './components/LatestBlogPosts';
// Component to handle scrolling to hash links when navigating from another page
function ScrollToHash() {
  const {
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash.replace('#', ''));
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [hash]);
  return null;
}
function HomePage() {
  useEffect(() => {
    document.title = 'IntelliEats — Scan Ingredients, Eat Smarter';
    const meta = document.createElement('meta');
    meta.name = 'google-adsense-account';
    meta.content = 'ca-pub-3041826185319356';
    document.head.appendChild(meta);
    let desc = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!desc) {
      desc = document.createElement('meta');
      desc.name = 'description';
      document.head.appendChild(desc);
    }
    desc.content = 'IntelliEats is a free ingredient scanner app that instantly detects unhealthy ingredients in packaged food. Scan any label with your camera to see which ingredients to avoid, limit, or enjoy — and make smarter, healthier choices in seconds.';
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
  return <main data-id="element-0">
      <HeroSection data-id="element-1" />
      <WhatItDoes data-id="element-2" />
      <HowItWorks data-id="element-3" />
      <WhyIngredientsMatter data-id="element-4" />
      <Features data-id="element-5" />
      <IngredientCategories data-id="element-6" />
      <IngredientDemo data-id="element-7" />
      <AppScreenshots data-id="element-8" />
      <Testimonials data-id="element-9" />
      <FAQ data-id="element-10" />
      <LatestBlogPosts data-id="element-11" />
      <DownloadCTA data-id="element-12" />
    </main>;
}
export function App() {
  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = 'https://cdn.magicpatterns.com/uploads/kYypn9DLGTyuEjc1d2cJka/intellieats_icon.webp';
  }, []);
  return <BrowserRouter data-id="element-13">
      <ScrollToHash data-id="element-14" />
      <div className="min-h-screen bg-white" data-id="element-15">
        <Navbar data-id="element-16" />
        <Routes data-id="element-17">
          <Route path="/" element={<HomePage data-id="element-19" />} data-id="element-18" />
          <Route path="/blog" element={<BlogPage data-id="element-21" />} data-id="element-20" />
          <Route path="/blog/:slug" element={<BlogPost data-id="element-23" />} data-id="element-22" />
          <Route path="/about" element={<AboutPage data-id="element-25" />} data-id="element-24" />
          <Route path="/guides/how-to-scan-pantry" element={<HowToGuide data-id="element-27" />} data-id="element-26" />
          <Route path="/privacy" element={<PrivacyPolicy data-id="element-29" />} data-id="element-28" />
          <Route path="/terms" element={<TermsOfService data-id="element-31" />} data-id="element-30" />
          <Route path="/contact" element={<ContactSupport data-id="element-33" />} data-id="element-32" />
          <Route path="/editorial-policy" element={<EditorialPolicy data-id="element-35" />} data-id="element-34" />
        </Routes>
        <Footer data-id="element-36" />
      </div>
    </BrowserRouter>;
}